export enum StyleConstants {
  NAV_BAR_HEIGHT = '80px',
}

export enum ScreenSizes {
  mobile = '575px',
  small = '767px',
  medium = '991px',
  large = '1260px',
  xlarge = '1920px',
}

// PLAN COLORS
export const TRIAL_PLAN_COLOR = '#d42c8e';
export const FREE_PLAN_COLOR = '#63b233';
export const LIGHT_PLAN_COLOR = '#2878cb';
export const STANDARD_PLAN_COLOR = '#de6536';

// COLORS
export const PRIMARY_BLUE_COLOR = '#1890ff';
export const PRIMARY_ADMIN_COLOR = '#2878cb';
export const PRIMARY_COLOR = '#63b233';
export const LIGHT_PRIMARY_COLOR = '#b1d999';
export const EXTRA_LIGHT_PRIMARY_COLOR = '#eff7eb';

export const BLUE_COLOR = '#2878cb';
export const ORANGE_COLOR = '#de6536';
export const PINK_COLOR = '#d42c8e';
export const RED_COLOR = '#c72a32';
export const WHITE_COLOR = '#ffffff';
export const DARK_GRAY_COLOR = '#a6a6a2';
export const GRAY_COLOR = '#d9d9d7';
export const BLACK_COLOR = '#262626';

export const LIGHT_BLUE_COLOR = '#94bce5';
export const LIGHT_ORANGE_COLOR = '#efb29b';
export const LIGHT_PINK_COLOR = '#ea96c6';
export const LIGHT_RED_COLOR = '#e39599';
export const LIGHT_GRAY_COLOR = '#f0f0ee';

export const EXTRA_LIGHT_BLUE_COLOR = '#e9f1fa';
export const EXTRA_LIGHT_ORANGE_COLOR = '#fcf0eb';
export const EXTRA_LIGHT_PINK_COLOR = '#fbeaf4';
export const EXTRA_LIGHT_RED_COLOR = '#f9eaea';
export const EXTRA_LIGHT_GRAY_COLOR = '#fafaf8';
export const EXTRA_DARK_GRAY_COLOR = '#595957';

export const SUCCESS_COLOR = '#52c41a';
export const WARNING_COLOR = '#faad14';
export const DANGER_COLOR = '#ff4d4f';

export const BACKGROUND_COLOR_1 = '#f0f0ee';
export const BACKGROUND_COLOR_2 = '#ffffff';

export const TEXT_COLOR = 'rgba(0, 0, 0, 0.85)';
export const TEXT_BLACK_COLOR = 'rgba(0, 0, 0, 0.9)';
export const TEXT_GRAY_COLOR = 'rgba(0, 0, 0, 0.6)';
export const TEXT_LIGHT_GRAY_COLOR = 'rgba(0, 0, 0, 0.55)';
export const PLACEHOLDER_COLOR = 'rgba(0, 0, 0, 0.3)';
export const TEXT_WHITE = '#ffffff';

// BORDER RADIUS
export const BORDER_RADIUS = '4px';
